
@if(recordedCourses.length > 0) {
  <section class="uc-home-courses" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container py-5">
      <h2 class="home-titles uc-home-section__title uc-display-sm" [class]="isRtl ? 'text-end' : 'text-start'" translate="home.recordedCourses"></h2>
      <ul *ngIf="recordedCourses?.length" class="d-flex flex-wrap align-items-center mt-4 mb-4">
        <li [ngClass]="{'active': !recordedFilter.parent}" (click)="onChangeCategory(null)" translate="mySpace.all"></li>
        <li [ngClass]="{'active': recordedFilter.parent === category.id}" *ngFor="let category of categories" (click)="onChangeCategory(category.id)" translate="{{isRtl ? category.nameAr : category.name}}"></li>
      </ul>
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 gy-4">
        <ng-container *ngIf="recordedCourses?.length; else courseLoader">
          <div class="col" *ngFor="let course of recordedCourses">
            <app-course-item [course]="course" context="home-recorded"></app-course-item>
          </div>
        </ng-container>
      </div>
      <div *ngIf="recordedCourses?.length" class="text-center mt-4">
        <a class="btn btn-see-more uc-see-more border rounded-pill px-3 py-2" routerLink="/course" translate="home.seeMore"></a>
      </div>
    </div>
  </section>
}

<ng-template #courseLoader>
  <div class="col" *ngFor="let course of [1,2,3,4]">
    <div class="course-loader">
      <div class="d-flex align-items-center justify-content-between">
        <span class="d-block rounded-pill"></span>
        <span class="d-block rounded-pill"></span>
      </div>
      <div></div>
      <div class="d-flex align-items-center justify-content-between">
        <span class="d-block rounded-pill"></span>
        <span class="d-block rounded-pill"></span>
      </div>
    </div>
  </div>
</ng-template>